import { ACDSessionManager, HttpClient, HttpUtilService } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';

export interface AcdApiConfig {
  baseUrl: string;
  authToken: string;
}

export function getAcdApiConfig(): AcdApiConfig | null {
  const acdSession = ACDSessionManager.instance;
  const baseUrl = acdSession.cxOneConfig?.acdApiBaseUri;
  const authToken = acdSession.accessToken;

  if (!baseUrl || !authToken) {
    return null;
  }

  return { baseUrl, authToken };
}

export async function acdApiGet(path: string, label: string): Promise<unknown> {
  const config = getAcdApiConfig();
  if (!config) {
    logger.error(`[CXone SDK] Missing config for ${label}`);
    return null;
  }

  const utilService = new HttpUtilService();
  const reqInit = utilService.initHeader(config.authToken, 'application/json');
  const url = `${config.baseUrl}${path}`;

  logger.debug(`[CXone SDK] ${label} URL:`, url);
  const response = await HttpClient.get(url, reqInit);
  logger.debug(`[CXone SDK] ${label} response:`, response);

  return response?.data || response;
}

export function extractArrayFromResponse(data: unknown, keys: string[]): unknown[] {
  if (Array.isArray(data)) {
    return data;
  }

  if (data && typeof data === 'object') {
    const record = data as Record<string, unknown>;
    for (const key of keys) {
      const value = record[key];
      if (Array.isArray(value)) {
        return value;
      }
    }
  }

  return [];
}
